import { events } from './events/index';
import { components } from './components/index';

const PartiesDocumentsSection = {
    events,
    components,
}

export { PartiesDocumentsSection };